export enum GoogleAPIkeys {
  Dobro = 'AIzaSyCOLX0LTS2Jlj_R378DfPi0q1dJ6-NHMho',
  Zito1 = 'AIzaSyCvC6LKN9hJcNvn5JFXKMxRitjGw8ksS0M',
  Zito2 = 'AIzaSyCjtBGyx7bRWCM6UZ5GAPw2TWsAVrmhQQ4'
}
